import { IsEnum, IsNumber, IsOptional, IsString } from '../../validators';
import { ApiProperty } from '../../codegen';

// ========== QUERY DTO ==========

export const LEADERBOARD_PERIOD_VALUES = [
  'today',
  'week',
  'month',
  'all',
] as const;
export type TLeaderboardPeriod = (typeof LEADERBOARD_PERIOD_VALUES)[number];

export class LeaderboardQueryDto {
  @ApiProperty()
  @IsEnum(LEADERBOARD_PERIOD_VALUES)
  period: TLeaderboardPeriod;
}

// ========== ENTRY DTOs ==========

export class GamesLeaderboardEntryDto {
  @ApiProperty()
  @IsOptional()
  @IsNumber()
  position: number | null;

  @ApiProperty()
  @IsNumber()
  userId: number;

  @ApiProperty()
  @IsString()
  name: string;

  @ApiProperty()
  @IsNumber()
  games: number;

  @ApiProperty()
  @IsNumber()
  wins: number;
}

export class WinningsLeaderboardEntryDto {
  @ApiProperty()
  @IsOptional()
  @IsNumber()
  position: number | null;

  @ApiProperty()
  @IsNumber()
  userId: number;

  @ApiProperty()
  @IsString()
  name: string;

  @ApiProperty()
  @IsNumber()
  winnings: number;
}

export class StreakLeaderboardEntryDto {
  @ApiProperty()
  @IsOptional()
  @IsNumber()
  position: number | null;

  @ApiProperty()
  @IsNumber()
  userId: number;

  @ApiProperty()
  @IsString()
  name: string;

  @ApiProperty()
  @IsNumber()
  streak: number;
}
